export default "__VITE_ASSET__CKWwgHB5__"